<div class="modal-content">
    <div class="modal-header modal-">
      <h2>Relación Usuario</h2>
      <button
        type="button"
        class="btn-close"
        data-bs-dismiss="modal"
        aria-label="Close"
        (click)="resetForm()"
      ></button>
    </div>
    <div class="modal-body">
      <form [formGroup]="form" (ngSubmit)="guardarRelacionUsario()">
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-12 form-inline">
              <label>Empleado: {{ usuario?.IdEmpleado }} - {{ usuario?.Nombre }}</label>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 form-group">
              <label for="ddlNegocio">Negocio:</label>
              <select
                class="form-control"
                id="ddlNegocio"
                name="ddlNegocio"
                formControlName="negocio"
                (change)="changeRegiones($event)"
              >
                <option value="0" disabled>Seleccione...</option>
                <option value="{{ ne.Negocio_Id }}" *ngFor="let ne of negocios">
                  {{ ne.Negocio_Descripcion }}
                </option>
              </select>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label for="ddlRegionesEdit">Región:</label>
                <select
                  class="form-control"
                  id="ddlRegionesEdit"
                  formControlName="region"
                  (change)="changeEstaciones($event)"
                >
                  <option value="0" disabled>Seleccione...</option>
                  <option
                    value="{{ region.IdRegion }}"
                    *ngFor="let region of regiones"
                  >
                    {{ region.Nombre }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="ddlEstacionesEdit">{{ lblEstacion }}:</label>
                <select
                  class="form-control"
                  id="ddlEstacionesEdit"
                  name="ddlEstacionesEdit"
                  formControlName="estacion"
                >
                  <option value="0" disabled selected>Seleccione...</option>
                  <option
                    value="{{ estacion.IdEstacion }}"
                    *ngFor="let estacion of estaciones"
                  >
                    {{ estacion.Nombre }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group" *ngIf="isSuper">
                <label for="selectRol">Asignar Rol</label>
                <select
                  class="form-control"
                  id="selectRol"
                  name="selectRol"
                  formControlName="rol"
                >
                  <option value="0" disabled selected>Seleccione...</option>
                  <option value="{{ rol.IdRol }}" *ngFor="let rol of roles">
                    {{ rol.Descripcion }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="text-right">
              <button class="btn btn-success" type="submit">Relacionar</button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
  